<!-- <div *ngIf="this.loader.getLoading()" class="cssload-container">  -->
  <div class="outer-loader" *ngIf="this.loader.getLoading()">
    <div class="spinner-border-outer">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div> 
    </div>
  </div>
<!-- </div> -->